import api from "@/lib/axiosConfig";
import { useMutation } from "@tanstack/react-query";

export interface SendMessageContactForm {
  message: string;
  subject: string;
  sendCopyToUser?: boolean;
}

const sendMessageContact = async (message: SendMessageContactForm) => {
  return await api.post(`back/api/mail/contact-form`, message, {
    headers: {
      instance: localStorage.getItem("instance"),
    },
  });
};

export const useSendMessageContact = () => {
  return useMutation({
    mutationFn: sendMessageContact,
  });
};
